import React from 'react'
import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

const FavoriteTutorsPopup = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    placement="bottom-end"
    disableFocusListener
    disableHoverListener
    disableTouchListener
  />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FEEBDD',
    boxShadow: '0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)',
    padding: 0,
    borderRadius: 10,
    minWidth: 700,
  },
}))

export default FavoriteTutorsPopup
